// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__HbCQn","featuredPost":"Blog_featuredPost__eaJxb","listPosts":"Blog_listPosts__Xs0AM"};